<template>
  <div class="service-form-success">
    <div class="service-form-success-icon">
      <z-icon class-prefix="zziconfont" name="check" />
    </div>
    <p>地址修改成功后，</p>
    <p>快递会先寄送到原地址，</p>
    <p>然后转运至新地址，请持续关注物流信息</p>
  </div>
</template>

<script>
import { Icon } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter'
import { hideShareButton, closeZljRefresh } from '../../../lib/utils'

export default {
  name: 'serviceFormSuccess',
  components: {
    'z-icon': Icon
  },
  data() {
    return {
    }
  },
  created() {
    hideShareButton()
    closeZljRefresh()
    native.setTitle({
      title: '提交成功'
    })
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="less" scoped>
  @import "../../../assets/css/base.less";
  .service-form-success {
    padding-top: 200px;
    &-icon {
      width: 80px;
      margin: 0 auto;
      font-size: 80px;
      color: green;
    }
    p {
      text-align: center;
      font-size: 32px;
      margin-bottom: 8px;
    }
  }
</style>
